import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import {Helmet} from "react-helmet";

export default class BlogDetail extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina Blog | Articles | Observations'}</title>
          <meta name="description" content="How to Tell a Fear of Failure to Suck It article by Kat Medina, author of the book, The Joys of Jet Lag. How to free yourself from a fear of failure or rejection so you can accomplish your dreams." />
        </Helmet>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Failure and rejection. These two words have the power to make the majority of mankind’s butt pucker out of fear. Few other beliefs are capable of preventing people from achieving that which they’re capable of and keep them from even trying. Hopes and dreams are stamped out like a flaming bag of poop on your front porch. When you attempt to prevent failure by not trying, you might think that you’re protecting yourself, but in reality, you’re just getting scorched crap all over your shoes.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The illusion of failure leads us to fail more than anything. When we limit ourselves and don’t try something because we are scared that we’ll be rejected or won’t succeed, we end up being the ones doing the rejecting. We reject the potential for growth, progress, and accomplishment. We reject life. We choose to live in a state of shitty-ass comfort and as a result, we have a mediocre existence of perceived safety.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'I used to avoid rejection and failure at all costs. I chased perfection and if I made a mistake, I would destructively ruminate over it to the point of exhaustion. If I was rejected or felt I failed, I would be consumed by shame and completely miss the lesson it was meant to teach me. Instead of learning from it, improving, and then letting it go, I used it as a warning to not be so vulnerable in the future.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'My fear of failure started to prevent me from even trying. As a result, I stopped growing. It seemed safer but it was boring as hell because when you’re not growing, you’re not living.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'For years I dreamt of writing a book and becoming a published author. It was a nagging thought that never left me alone and I even attempted a chapter or two over the years. Each time I would end up throwing in the towel, focusing on the loud inner critic that worried how it would be received by the masses, fearing it was not good enough. That I was not good enough. Every attempt at pursuing my writing was interrupted by fear.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'In December of 2018, I finally had enough. Like so many other breakthroughs, it was more painful to stay the same than to say fuck it and take action. The inner voice calling me to go for it became louder than the annoying inner critic.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Writing is an interesting pursuit for someone who dreads failing and attempts to avoid rejection. You bare your heart and soul through your words, and if you want anyone other than yourself to read them, then you are guaranteed to be rejected and criticized at some point. So in order to keep at it, I had to redefine failure.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Instead of seeing failure as any sort of criticism, rejection, mistake, or unmet expectations, I made it much easier for me to feel as if I succeeded.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'I decided that failure was not trying. It was not learning or growing. Anytime I tried, did my best, gave something my all, learned, grew, or saw the humor, then I had succeeded. Maybe changing definitions is a little delusional, but I couldn’t deny the positive impact it had on me.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Whenever my article submissions or book queries were declined (which was more often than I’d like to admit), I would view it as proof that I was pursuing my dreams and going all in. I wasn’t just waiting along the sidelines; I was participating in the fucking race. And that was a massive success.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'I knew in my core that the only way I was guaranteed to fail was if I didn’t try.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'This belief propelled me forward on the pursuit of some huge dreams. Achieving them was unlikely but knowing that I was trying my best made me feel like I was living fully. The inner voice and inner critic were rooting me on because I was the underdog that was actually going for it against the odds. I refused to bury my dreams without ever having let them live.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'I’m curious, what is the voice within you calling you to do before you die? I believe that each and every one of us was born with a unique set of gifts that we were meant to share with the world and all of our experiences have happened to shape us and further develop those gifts.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'When you show up as authentically as you can and allow yourself to be guided by that voice, you are able to contribute to the world in the way that you, and you alone, were born to do. And that is the truest form of success.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'So that leads me to one final question–what would you do if you knew you could not fail?'}
          </p>
        </ScrollFadeIn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/blogDetail/failure.js